
const subjects = Object.freeze({
  KOKUGO: 'ko',
  SHAKAI: 'sh',
  SUGAKU: 'su',
  RIKA: 'ri',
  EIGO: 'ei',
  CHIRI: 'ch',
  REKISHI: 're',
  KOUMIN: 'mi',
  GIJUTSU: 'gi',
  ZAIRYO: 'za',
  SEIBUTSUIKUSEI: 'se',
  ENERGY: 'en',
  JOHO: 'jo',
  KATEI: 'ka',
  SHOKUSEIKATSU: 'ss',
  ISEIKATSU: 'is',
  SHOHISEIKATSU_KANKYO: 'sk',
  KAZOKU_CHIIKI: 'kc',
  HOKEN_TAIIKU: 'ht',
  HOKEN: 'ho',
  TAIIKU_JITSUGI: 'ta',
  TAIIKU_RIRON: 'tr'
})

const hasOptionSubjects = Object.freeze([
  subjects.SHAKAI,
  subjects.GIJUTSU,
  subjects.KATEI,
  subjects.HOKEN_TAIIKU,
])

const skillSubjects = Object.freeze([
  subjects.GIJUTSU,
  subjects.KATEI,
  subjects.HOKEN_TAIIKU,
])

const publisherNoneSubjecs = Object.freeze([
  subjects.TAIIKU_JITSUGI,
  subjects.TAIIKU_RIRON,
])

const grades = Object.freeze({
  CHU1: 't1',
  CHU2: 't2',
  CHU3: 't3',
})

const difficulties = Object.freeze({
  EASY: '1',
  STANDARD: '2',
  DIFFICULT: '3',
})

const materialKinds = Object.freeze([
  //sheet.jsでの処理用にkeyを`id`にしている
  {id:'general',  name:'新学社教材'},
  {id:'test',     name:'新学社実力テスト'},
  {id:'original', name:'オリジナル問題'},
])

// 解答重複チェックしない解答形式のcode
const nonCheckAnswerFormatCodes = Object.freeze([
  'ko03',
  'su02',
  'ei03',
  'ri01',
  'sh03'
])

const step = Object.freeze({
  REPLACE_CONTENT: 1,
  PREVIEW: 2,
  SCORE_SETTING: 3,
  SHEET_NAMING:4,
  COMPLETED: 5,
})

export default Object.freeze({
  subjects: subjects,
  hasOptionSubjects: hasOptionSubjects,
  skillSubjects: skillSubjects,
  publisherNoneSubjecs: publisherNoneSubjecs,
  grades: grades,
  difficulties: difficulties,
  materialKinds: materialKinds,
  step: step,
  nonCheckAnswerFormatCodes: nonCheckAnswerFormatCodes,
})
